import angular from 'angular';

import DataBroker from 'cars-ng-data-broker';
import Employees from 'cars-ng-employees';
import component from './employeeDataAdapter.component';
import service from './employeeDataAdapter.service';
import activeTest from '../carsNgActiveTest';

export default angular
    .module('vdp.employeeDataAdapter', [DataBroker, Employees, 'cars.ui.angular', activeTest])
    .service('employeeDataAdapter', service)
    .decorator('employeeReviewsModalService', [
        '$delegate',
        'employeeDataAdapter',
        function decorator($delegate, employeeDataAdapter) {
            // The reviews endpoint is different.
            $delegate.fetchEmployeeReviewData =
                employeeDataAdapter.fetchReviews;

            return $delegate;
        }
    ])
    .component('vehicleDetailPageEmployeeDataAdapter', component).name;